import { EventEmitter } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Map } from 'maplibre-gl';

import { AbstractMapControl } from '@connect-services/client/components/map/abstract-map-control';
import { MapToImageService } from '@connect-services/client/services/map-to-image.service';

export class MapExportControl extends AbstractMapControl {
    public mapExportToggled: EventEmitter<void> = new EventEmitter<void>();

    public constructor(
        map: Map,
        private readonly mapToImageService: MapToImageService,
        private readonly translocoService: TranslocoService,
    ) {
        super(mapToImageService.button);
        this.map = map;
    }

    public updateVisibility(disabled: boolean): void {
        this.mapToImageService.isMapExportControlDisabled.set(disabled);
        this.setVisible(!disabled);

        if (disabled) {
            this.mapToImageService.isMapExportActive.set(false);
        }

        this.refreshButton();
    }

    protected initButton(): void {
        this.setupButton('map-export-control', () => this.handleControl(), ['map-export-control']);
        this.refreshButton();
    }

    private handleControl(): void {
        if (!this.map) {
            return;
        }

        if (this.mapToImageService.isMapExportControlDisabled()) {
            return;
        }

        this.mapToImageService.isMapExportActive.set(!this.mapToImageService.isMapExportActive());
        this.mapExportToggled.emit();

        this.refreshButton();
    }

    private refreshButton(): void {
        this.mapToImageService.setControlButtonIcon();

        this.setButtonState({
            isActive: this.mapToImageService.isMapExportActive(),
            isDisabled: this.mapToImageService.isMapExportControlDisabled(),
        });

        this.setTooltip();
    }

    private setTooltip(): void {
        if (this.mapToImageService.isMapExportControlDisabled()) {
            this.setButtonTitle('');

            return;
        }

        this.setButtonTitle(this.translocoService.translate('exportMapImage'));
    }
}
